import React from 'react';
import { useHistory } from 'react-router';
import { BiCheckCircle, BiXCircle, BiTimeFive } from 'react-icons/bi';
import BitaButton from '../../../../bitaComponents/BitaButton/BitaButton';
import BitaModal from '../../../../bitaComponents/BitaModal/BitaModal';
import style from '../../PortfolioBasketCalculation.module.scss';
import BitaTable from '../../../../bitaComponents/BitaTable/BitaTable';
import { BASKET_STATUS } from '../../utils/constants';

const styleClose = {
  position: 'absolute',
  fontSize: '30px',
  fontWeight: 'bold',
  top: '-10px',
  right: '0',
  cursor: 'pointer',
  padding: '10px',
  boxSizing: 'border-box',
};

const SaveSuccessModal = ({ showModal, setShowModal, resetValues, processedBaskets }) => {
  const history = useHistory();
  // Use react-icons for status icons

  const CustomRowComponent = ({ data, index, entryKey, value }) => {
    if (entryKey === 'status') {
      return (
        <div>
          {data.status === BASKET_STATUS.UPDATED || data.status === BASKET_STATUS.CREATED ? (
            <BiCheckCircle
              color="#28a745"
              size={20}
              title="Success"
              style={{ verticalAlign: 'middle' }}
            />
          ) : data.status === BASKET_STATUS.ERROR ? (
            <BiXCircle
              color="#dc3545"
              size={20}
              title="Failed"
              style={{ verticalAlign: 'middle' }}
            />
          ) : data.status === BASKET_STATUS.PENDING ? (
            <BiTimeFive
              color="#ffc107"
              size={20}
              title="Pending"
              style={{ verticalAlign: 'middle' }}
            />
          ) : null}
        </div>
      );
    }
    return <div>{value}</div>;
  };

  return (
    <BitaModal
      isModalOpen={showModal}
      setModalState={() => {
        setShowModal(false);
        setShowModal(false);
        resetValues();
      }}
      customStyle={{ width: '70%' }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px 0',
        }}
      >
        <span
          onClick={() => {
            setShowModal(false);
            resetValues();
          }}
          style={styleClose}
        >
          &times;
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className={style.modalTextTitleSmall}>Basket Submissions Successful</div>
        {processedBaskets && processedBaskets.length > 0 && (
          <div style={{ width: '100%', marginTop: '20px' }}>
            <BitaTable
              equalColumnsWidth
              spacedRows
              data={processedBaskets}
              CustomRowComponent={CustomRowComponent}
              search={false}
              showFields={Object.keys(processedBaskets[0] || {})}
              height="400px"
              showOnly={7}
              pagination
              selectAction={() => {}}
            />
          </div>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '60px' }}>
        <BitaButton primaryWhite onClick={() => history.push('/')} height="35px" width="200px">
          Go to Home
        </BitaButton>
        <BitaButton
          primaryWhite
          onClick={() => {
            setShowModal(false);
            resetValues();
          }}
          height="35px"
          width="200px"
        >
          Submit another basket
        </BitaButton>
      </div>
    </BitaModal>
  );
};

export default SaveSuccessModal;
